import {
    useCallback,
    useEffect,
    useMemo,
    useState
} from 'react';
import { useSelector } from 'react-redux';

import { React } from '../../../common';
import { getManualVisitors } from '../../../selectors/forms';
import { parseToDdMmYyyy } from '../../../utils';
import {
    NewVisitorInlineForm,
    selectOptionsWithForm
} from '../snippets/VisitorSelector';
import { ComboboxSelector } from './ComboboxSelector';
import { getProfileHint } from './visitorsListOperations';

const getNameFunction = (item) => {
    if (item?.isMe) {
        return Object.R('titles.for_me');
    }
    const bd = item?.birthday ? ` (${parseToDdMmYyyy(item.birthday)})` : '';
    const name = item?.manual
        ? `${item?.firstName} ${item?.lastName}`
        : item?.firstLastName || item?.name || item?.fullNameRu;
    return `${name}${bd}`;
};

export const ProfileSelector = React.memo(
    ({
        selected,
        onChange,
        enabled = true,
        data = [],
        hasManual = true,
        sectionStyle = { marginTop: 14 },
        isError,
        orderId,
        onAddToFamily,
    }) => {
        const [ selectedProfile, setSelectedProfile ] = useState(selected);
        const manualVisitors = useSelector(getManualVisitors)
            ?.filter(
                ({
                    fullNameRu: name,
                    birthday: bd,
                }) =>
                    !data?.find(({
                        fullNameRu,
                        birthday,
                    }) => fullNameRu === name && birthday === bd),
            );
        !orderId &&
        manualVisitors.push({
            id: 'newVisitor',
            name: Object.R('titles.newVisitor'),
            FormComponent: NewVisitorInlineForm,
        });

        const visitors = useMemo(()=> {
            const res = [ ...data, ...(hasManual ? manualVisitors : []) ];
            if (!res?.find?.(({ isMe }) => isMe) && !orderId) {
                res.splice(0, 0, {
                    id: 'empty',
                    isMe: true,
                    name: Object.R('titles.for_me'),
                });
            }
            return res;
        }, [data,
            hasManual,
            manualVisitors,
            orderId]);


        useEffect(() => {
            setSelectedProfile(selected);
        }, [ selected ]);

        const onSelectVisitor = (item, addFields, newVisitor) => {
            if (item?.id === 'newVisitor') {
                onChange(newVisitor);
            } else {
                onChange(item);
            }
        };

        const onPressHandler = useCallback(() => {
            selectOptionsWithForm({
                title: 'titles.select_visitor',
                autoHeight: true,
                data: visitors,
                selected: selectedProfile?.manual ? `${selectedProfile?.fullNameRu ?? ''}` : selectedProfile?.id ?? selectedProfile?._id,
                onSelect: onSelectVisitor,
                getName: getNameFunction,
                onAddToFamily: (f) => {
                    onAddToFamily?.(f);
                }
            });
        }, [selectedProfile?.manual,
            selectedProfile?.fullNameRu,
            selectedProfile?.id,
            visitors,
            onSelectVisitor,
            onAddToFamily]);

        return (
            <ComboboxSelector
                title={'titles.whose_visit'}
                value={getProfileHint(selectedProfile)}
                enabled={enabled}
                onPressHandler={onPressHandler}
                sectionStyle={sectionStyle}
                isError={isError}
            />
        );
    },
);
